import { Component } from '@angular/core';
import {AlertController, IonicPage, NavController, NavParams} from 'ionic-angular';
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {AppChallengeInAppPage} from "../app-challenge-in-app/app-challenge-in-app";
import {ApiProvider} from "../../providers/api/api";
import {ApiCourseDataProvider} from "../../providers/api-course-data/api-course-data";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {AppChallengeUserPage} from "../app-challenge-user/app-challenge-user";

/**
 * Generated class for the AppChallengeIntroPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-challenge-intro',
  templateUrl: 'app-challenge-intro.html',
})
export class AppChallengeIntroPage {

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController,
    private contentTranslation: ContentTranslationProvider,
    private apiCourseDataProvider: ApiCourseDataProvider,
    private userState: UserStateProvider,
  ) {
    this.apiCourseDataProvider.getCourseData().then();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppChallengeIntroPage');
  }

  openInAppChallengeList() {
    this.navCtrl.push(AppChallengeInAppPage);
  }

  openChallengeUser() {
    if (!this.userState.user.challengeStatus) {
      this.openChallengeNotAvailableModal();
    } else {
      this.navCtrl.push(AppChallengeUserPage);
    }
  }

  openChallengeNotAvailableModal() {
      const alert = this.alertCtrl.create({
        title: this.contentTranslation.translateContent('Challenge Second 30 day not available title '),
        subTitle: this.contentTranslation.translateContent('Challenge Second 30 day not available text'),
        buttons: [
          {
            text: 'OK',
          },
          {
            text: '×',
            cssClass: 'close-button'
          }
        ],
        cssClass: 'ip-alert ip-with-close'
      });
      alert.present();
  }

  goBack() {
    this.navCtrl.parent.select(0);
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-challenge-intro/app-challenge-intro.ts